import { actionCreators } from "../reducers/modalMessage";
import { AppDispatch } from "../../index";

export const resetModalMessage = () => (dispatch: AppDispatch) => dispatch(actionCreators.reset());
